import styled from 'styled-components';
import themeData from '../../../../utils/theme/themeData';

const { typography } = themeData;

export const FormGrid = styled.div`
  display: grid;
  grid-template: 1fr / 1fr 1fr;
  gap: 20px;
  padding: 24px 16px;
`;

export const FormFieldWrapper = styled.div`
  ${({ span }) =>
    span &&
    `
    grid-column-end: span ${span};
  `}
`;

export const FormLabel = styled(typography.TitleTwoTypography)`
  margin: 0;
`;

export const FormTextInput = styled.input`
  width: 100%;
  height: 36px;
  padding: 8px 15px;
  font-size: 13px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black};
  border: 1px solid ${({ theme }) => theme.colors.grey006};
  border-radius: 4px;
  box-sizing: border-box;

  ::-webkit-input-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  ::-moz-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  :-ms-input-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  :-moz-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }

  &:focus {
    border: 1px solid ${({ theme }) => theme.colors.grey006};
    outline: none;
  }
`;

export const FormValidationError = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.redDark};
`;
